import React, {useEffect, useState} from "react";
import { Link } from "react-router-dom";
import { utils } from "../../core/helpers";
import { useSelector } from "react-redux";
import { RootState } from "../../core/redux/store";

const CategoriesGrid = ({ data, onSelect }: any) => {
    const [gridData, setGridData] = useState(data);
    const { user } = useSelector((state: RootState) => state.user);

    const handleClick = (clickedItem: any) => {
        const newData = gridData.map((item: any) => {
            if (item.value === clickedItem.value) {
                return { ...item, selected: !item.selected };
            }
            return { ...item, selected: false };
        });

        setGridData(newData);

        if (onSelect) {
            onSelect(newData);
        }
    };

    return (
        <div className="container">
            <div className="row course-category">
                {gridData.map((x: any, index: number) => {
                    return (
                        <div
                            className="col-lg-4 col-md-6 d-flex mb-2"
                            key={index}
                            onClick={() => handleClick(x)}
                        >
                            <div
                                className={
                                    "course-category-item h-100 w-100 d-flex flex-column justify-content-center " +
                                    (x.selected ? "bg-success" : "")
                                }
                            >
                                <div className="d-flex flex-row justify-content-between align-items-center">
                                    <div className="d-flex align-items-center">
                                        <img
                                            className="img-fluid category-image"
                                            style={{ width: "68px", height: "68px" }}
                                            src={x.icon}
                                            alt={x.name}
                                            loading="lazy"
                                        />
                                        <div>
                                            <h6 className="pe-2">
                                                <Link to="#">{x.name}</Link>
                                            </h6>
                                            <p className="mb-0 text-muted">{x.description}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default CategoriesGrid;